var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsychologicalHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15206_415065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7345 3C15.9148 3 14.3643 3.49557 14.3643 5.37025C14.3643 7.68682 12.5484 9.58227 10.2657 9.72082L10.2659 3.53148H11.6838C11.8304 3.53148 11.9495 3.41241 11.9495 3.26576C11.9495 3.11911 11.8304 3.00004 11.6838 3.00004H8.31662C8.16996 3.00004 8.0509 3.11911 8.0509 3.26576C8.0509 3.41241 8.16996 3.53148 8.31662 3.53148H9.73449V9.72082C7.452 9.58248 5.63597 7.68686 5.63597 5.37025C5.63597 3.49553 4.08569 3 3.26572 3C3.11907 3 3 3.11907 3 3.26572C3 3.41237 3.11907 3.53144 3.26572 3.53144C3.3409 3.53144 5.10453 3.5522 5.10453 5.37025C5.10453 7.98044 7.15808 10.1198 9.73449 10.2583V16.4686H8.31662C8.16996 16.4686 8.0509 16.5876 8.0509 16.7343C8.0509 16.8809 8.16996 17 8.31662 17H11.6838C11.8304 17 11.9495 16.8809 11.9495 16.7343C11.9495 16.5876 11.8304 16.4686 11.6838 16.4686H10.2659V10.2583C12.8423 10.12 14.8958 7.98044 14.8958 5.37025C14.8958 3.5648 16.6555 3.53216 16.7351 3.53144C16.8816 3.53129 17.0004 3.41237 17.0004 3.26572C17.0002 3.11892 16.8815 3 16.7345 3Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15206_415065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychologicalHelp);
export default __webpack_public_path__ + "static/media/psychological-help.fc0ab2f7.svg";
export { ForwardRef as ReactComponent };